import { render, staticRenderFns } from "./RecordsServices.vue?vue&type=template&id=8706a3ea&scoped=true"
import script from "./RecordsServices.vue?vue&type=script&lang=js"
export * from "./RecordsServices.vue?vue&type=script&lang=js"
import style0 from "./RecordsServices.vue?vue&type=style&index=0&id=8706a3ea&prod&lang=scss&scoped=true"
import style1 from "./RecordsServices.vue?vue&type=style&index=1&id=8706a3ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8706a3ea",
  null
  
)

export default component.exports